/* eslint-disable perfectionist/sort-objects */
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import type { Role } from '@packages/contracts';

export interface User {
	candidateId: string

	email: string
	roles: Role[]
	uid:   string
}

interface AuthState {
	isAuthenticated: boolean
	status:          'authenticated' | 'loading' | 'unauthenticated'
	user:            null | User

	clearAuth: () => void
	setAuth:   (user: User) => void
}

export const useAuthStore = create<AuthState>()(persist(
	set => ({
		user:            null,
		status:          'loading',
		isAuthenticated: false,
		clearAuth:       () =>
			set({
				isAuthenticated: false,
				status:          'unauthenticated',
				user:            null,
			}),
		setAuth: (user: User) =>
			set({
				isAuthenticated: true,
				status:          'authenticated',
				user,
			}),
	}),
	{
		name:       'auth-storage',
		partialize: state => ({
			isAuthenticated: state.isAuthenticated,
			status:          state.status,
			user:            state.user,
		}),
	},
));
